import axios from "./axiosInstance";

const aboutAPI ={ 
    leaders_api: () => axios.get("our-leaders"),
    visitors_guests_api: () => axios.get("visitors-guests"),
    our_philosphy:() => axios.get("our-philosophy"),
    listing: () => axios.get("about-us"),
    alumni: () => axios.get("alumni"),
    branches: () => axios.get("branches"),
    alumni_form: (payload) => axios.post("alumni-form", payload),
    certificates: () => axios.get("certificates")
    
}

export default aboutAPI;